import { Modal } from "antd";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import alert from "components/elements/Alert";

import useOptions from "features/masterData/hooks/useOptions";
import * as services from "../services/companyApi";
import { setIsLoading } from "../slices/companySlice";
import { getTaxConpany } from "features/masterData/services/optionsApi";
import { generateRandomString } from "utils/helper";
import debounce from "lodash.debounce";
import { useTranslation } from "react-i18next";

function toParams(params = {}) {
  const modifiedParams = {
    ...params,
    subDistrictId: params.subdistrictId,
    colorCode: ["#1D76DB", "#1D76DB", "#1D76DB", "#1D76DB"],
  };
  return modifiedParams;
}

function useCompanyProfileCreate() {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isLoading = useSelector((state) => state.company.isLoading);
  const { currentCompany, currentEmployee } = useSelector((state) => state.company);
  const [currentStep, setCurrentStep] = useState(0);
  const [infoValues, setInfoValues] = useState({});
  const [addressValues, setAddressValues] = useState({});
  const [contactValues, setContactValues] = useState({});
  const {
    companyTypeOptions = [],
    sourceProvinceOptions = [],
    sourceDistrictOptions = [],
    sourceSubDistrictOptions = [],
    getMstCompanyTypeOptions = () => { },
    getProvinceOptions,
    getDistrictOptions,
    getSubDistrictOptions,
    clearDistrictOptions,
    clearSubDistrictOptions,
  } = useOptions();

  const [optionSearchTax, setOptionSearchTax] = useState([])


  const provinceOptionsTh = useMemo(() => {
    const modifiedOptions = sourceProvinceOptions.map((opt) => ({
      ...opt,
      label: opt.provinceName,
      value: opt.provinceId,
    })).sort((a, b) => a.label.localeCompare(b.label));
    return modifiedOptions;
  }, [sourceProvinceOptions]);

  const provinceOptionsEn = useMemo(() => {
    const modifiedOptions = sourceProvinceOptions.map((opt) => ({
      ...opt,
      label: opt.provinceNameEn,
      value: opt.provinceId,
    })).sort((a, b) => a.label.localeCompare(b.label));
    return modifiedOptions;
  }, [sourceProvinceOptions]);

  const districtOptionsTh = useMemo(() => {
    const modifiedOptions = sourceDistrictOptions.map((opt) => ({
      ...opt,
      label: opt.districtName,
      value: opt.districtId,
    })).sort((a, b) => a.label.localeCompare(b.label));
    return modifiedOptions;
  }, [sourceDistrictOptions]);

  const districtOptionsEn = useMemo(() => {
    const modifiedOptions = sourceDistrictOptions.map((opt) => ({
      ...opt,
      label: opt.districtNameEn,
      value: opt.districtId,
    })).sort((a, b) => a.label.localeCompare(b.label));
    return modifiedOptions;
  }, [sourceDistrictOptions]);

  const subDistrictOptionsTh = useMemo(() => {
    const modifiedOptions = sourceSubDistrictOptions.map((opt) => ({
      ...opt,
      label: opt.subDistrictName,
      value: opt.subDistrictId,
    })).sort((a, b) => a.label.localeCompare(b.label));
    return modifiedOptions;
  }, [sourceSubDistrictOptions]);

  const subDistrictOptionsEn = useMemo(() => {
    const modifiedOptions = sourceSubDistrictOptions.map((opt) => ({
      ...opt,
      label: opt.subDistrictNameEn,
      value: opt.subDistrictId,
    })).sort((a, b) => a.label.localeCompare(b.label));
    return modifiedOptions;
  }, [sourceSubDistrictOptions]);

  const nextStep = () => {
    setCurrentStep(currentStep + 1);
  };

  const prevStep = () => {
    setCurrentStep(currentStep - 1);
  };

  const getTaxConpanyOption = useCallback(debounce(
    async ({ searchtext = "" }) => {
      try {
        dispatch(setIsLoading(true));
        const values = {
          requestId: generateRandomString(),
          companyId: currentCompany,
          employeeId: currentEmployee,
          searchtext
        };
        const response = await getTaxConpany(values);
        console.log("response?.data", response?.data);
        // console.log("res", response?.data?.data?.map(o => {
        //   return {
        //     ...o,
        //     label: o?.fullNameTh,
        //     value: o?.taxId
        //   }
        // }));
        // setSwitchWithOptions(response.data);
        setOptionSearchTax(response?.data?.data?.result?.map(o => {
          return {
            ...o,
            fullNameTh: o?.companyName?.fullNameTh,
            fullNameEn: o?.companyName?.fullNameEn,
            label: o?.companyName?.fullNameTh,
            value: o?.id,
            taxId: o?.id,
          }
        }))
      } catch (error) {
        // console.log("error", error);
        // Alert({ type: "error", resultObject: error });
      } finally {
        dispatch(setIsLoading(false));
      }
    }, 1000), []);

  const createCompany = useCallback(
    async (values) => {
      try {
        dispatch(setIsLoading(true));
        await services.createCompany(
          toParams({
            ...values,
            companyId: currentCompany,

          })
        );
        alert({ message: "Success" });
        navigate("/configuration/company");
      } catch (error) {
        alert({ type: "error", resultObject: error });
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [dispatch, navigate]
  );

  const onCancel = useCallback(() => {
    window.history.back();
  }, []);

  const handleProviceChange = useCallback(
    (val) => {
      clearDistrictOptions();
      clearSubDistrictOptions();
      if (val) {
        getDistrictOptions({ provinceId: val });
      }
    },
    [clearDistrictOptions, clearSubDistrictOptions, getDistrictOptions]
  );

  const handleDistrictChange = useCallback(
    (val) => {
      clearSubDistrictOptions();
      if (val) {
        getSubDistrictOptions({ districtId: val });
      }
    },
    [clearSubDistrictOptions, getSubDistrictOptions]
  );

  const onCompanyInfoSubmit = (values = {}) => {
    setInfoValues((prev) => ({ ...prev, ...values }));
    nextStep();
  };

  const onCompanyAddressSubmit = (values) => {
    setAddressValues((prev) => ({ ...prev, ...values }));
    nextStep();
  };

  const onCompanyCreateSubmit = (values) => {
    // setContactValues((prev) => ({ ...prev, ...values }));
    Modal.confirm({
      title: t("dialog.confirmation.header"),
      content: (i18n.language === "en" ?
        <span>Are you sure confirm to create company ?</span>
        : <span>คุณแน่ใจที่จะยืนยันการสร้างบริษัทหรือไม่ ?</span>
      ),
      onOk() {
        const modifiedValues = {
          // ...infoValues,
          // ...addressValues,
          ...values,
          companyId: currentCompany,
        };
        createCompany(modifiedValues);
      },
      okText: t("common.confirm").toUpperCase(),
      cancelText: t("common.cancel").toUpperCase(),
    });
  };

  useEffect(() => {
    getMstCompanyTypeOptions();
  }, [getMstCompanyTypeOptions]);

  useEffect(() => {
    getProvinceOptions();
  }, [getProvinceOptions]);

  useEffect(() => {
    return () => {
      setInfoValues({});
      setAddressValues({});
      setContactValues({});
    };
  }, []);

  return {
    isLoading,
    currentStep,
    infoValues,
    addressValues,
    contactValues,
    companyTypeOptions,
    provinceOptionsTh,
    provinceOptionsEn,
    districtOptionsTh,
    districtOptionsEn,
    subDistrictOptionsTh,
    subDistrictOptionsEn,
    nextStep,
    prevStep,
    onCancel,
    handleProviceChange,
    handleDistrictChange,
    onCompanyInfoSubmit,
    onCompanyAddressSubmit,
    onCompanyCreateSubmit,
    getTaxConpanyOption,
    optionSearchTax
  };
}

export default useCompanyProfileCreate;
